<template>
  <div class="buttons has-addons is-centered" >
    <a :class="l==value ? 'button is-primary' : 'button is-outlined'" @click="onClick(l)" v-for="l in list[kind]" :key="l">{{l}}</a>
  </div>
</template>

<script>
export default {
  name: 'RadioButtons',
  props: {
    kind : String,
    value : String,
    mandatory : Boolean
  },
  data: function () {
    return {
      lastValue: '',
      list :  {
        'lang' : ['eng', 'ger', 'ita','pol','hrv'],
        'wclass' : ['fn', 'mn', 'ige', 'kif','text', 'egyéb']
      }
    }
  },
  methods: {
    onClick: function(_val){
      if ((_val == this.lastValue) && (!this.$props.mandatory)) {_val = '';}
      this.$emit('input', _val);
      this.lastValue = _val;
    }
  }
}
</script>

<style scoped>
</style>
